import React, {useState, useEffect} from 'react';
import axios from "axios";
// import './styles/sass/captcha.scss'
import { spaEndpointHost, vraUX, apiHost, getwayApi, captchaUrl } from "../../../config/Constants";
import { inputClasses } from '../../../formik/refactorOut/styles';
import PBV_icon from '../../assets/pbv.png';
import testLogo from '../form/styles/assets/verisma_logo.png';
import './captcha.scss';
import Captcha from './Captcha';
import { fetchCaptcha, submitCaptchaData } from '../../../functions/apiCalls';

export const CaptchaContainer = ({setCaptcha, formId, formSpec, dbFormSpec}) => {
    const [captchaRespObj, setCaptchaRespObj] = useState(null);
    const [userCatchaInput, setUserCatchaInput] = useState('');
    const [errorState, setErrorState] = useState(false);

    useEffect(() => {
      fetchCaptcha(captchaUrl, setCaptchaRespObj);
    }, [false]);
      
    if(formSpec === null){
      return <p></p>
    }

  return (
    <Captcha 
      testLogo = {testLogo}
      formSpec = {formSpec}
      captchaRespObj = {captchaRespObj}
      // formStyles = {formStyles}
      submitCaptchaData = {() => submitCaptchaData(captchaUrl, captchaRespObj, userCatchaInput, setCaptcha, setErrorState)}
      setUserCatchaInput = {setUserCatchaInput}
      errorState = {errorState}
      PBV_icon = {PBV_icon}
      dbFormSpec={dbFormSpec}
      formId={formId}
    />

  );
}